import { Editable } from "./editable.model";
import { IdentificationType } from "./identification-type.model";

export class Identification extends Editable {
    /** Unique internal identity of the identification. */
    public id: number;

    /** Unique internal identity of the contact associated with the identification. */
    public contactId: number;

    /** Unique internal identity of the identification type associated with the identification. */
    public identificationTypeId: number;

    /** The actual number and/or identifier, typically on the front of the identification. */
    public number: string;

    /** Further details about the identification type, where applicable. */
    public identificationType: IdentificationType;
    public type: IdentificationType;

    /** Name of the state or other entity that issued the identification. */
    public issuer: string;

    /** Indicates whether or not the identification is the primary one for the contact. */
    public primary: boolean;

    /** Date the identification expires, if any. */
    public expirationDate: Date;

    /** Date and time the identification was created. */
    public createdAt: Date;

    /** Date and time the identification was modified. */
    public updatedAt: Date;
}